module.exports = __webpack_public_path__ + "img/member_luckDraw_icon_431006.393cdddb.png";